export const videoConferenceData = {
  sessionId: '1_MX40NjQ3MjU2Mn5-MTY1OTYxNjUzNDEyNH4vMzZBQWh4dXZFYXpQVVMyZzhEVjFwdEh-fg',
  settings: null,
  isActive: true,
  connectedToWaitingRoom: [],
  sessionStarted: false,
  isScheduled: false,
  _id: '62ebbd16341ea74d92ac7273',
  createdBy: 248,
  hostId: 248,
  participants: [248, 173],
  createdAt: '2022-08-04T12:35:34.243Z',
  updatedAt: '2022-08-04T12:35:34.243Z',
  __v: 0,
  authToken:
    'T1==cGFydG5lcl9pZD00NjQ3MjU2MiZzaWc9Zjg1OTIzMGNlMzZkYTkzMTlmOGE2NGUyOWVmMjQ0YjE4ZjE4MzY1MjpzZXNzaW9uX2lkPTFfTVg0ME5qUTNNalUyTW41LU1UWTFPVFl4TmpVek5ERXlOSDR2TXpaQlFXaDRkWFpGWVhwUVZWTXlaemhFVmpGd2RFaC1mZyZjcmVhdGVfdGltZT0xNjU5NjE2NTM0Jm5vbmNlPTAuOTQ3Mzk5MzM0ODE1MzUwNCZyb2xlPXB1Ymxpc2hlciZleHBpcmVfdGltZT0xNjU5NzAyOTM0JmNvbm5lY3Rpb25fZGF0YT11c2VySWQlM0QyNDglM0J1c2VyVHlwZSUzRHByb3ZpZGVyLWFkbWluJTNCaXNIb3N0JTNEeWVzJmluaXRpYWxfbGF5b3V0X2NsYXNzX2xpc3Q9',
  participantsData: [
    {
      id: 173,
      fullName: 'Brian M.',
      avatarName: 'BM',
      userType: 'patient',
      timezone: 'America/Blanc-Sablon',
      userId: 173,
      isActive: true,
    },
    {
      id: 248,
      fullName: 'Alice i.',
      avatarName: 'Ai',
      userType: 'provider-admin',
      timezone: 'America/Cayenne',
      userId: 248,
      isActive: true,
      hostFullName: 'Alice in Chains',
    },
  ],
};
